const TOP_NAV = {
  DROPDOWN_CLICK: {
    action: "click",
    category: "dropdown",
  },
  MORE_CLICK: {
    action: "click",
    category: "top nav",
    label: "more categories",
  },
  NAV_LINK_CLICK: {
    action: "click",
    category: "top nav",
  },
};

const PRODUCT = {
  CARD_CLICK: {
    action: "click",
    category: "Product Card",
  },
  CARD_IMPRESSION: {
    action: "impression",
    category: "Product Card",
  },
  CAROUSEL_SEE_MORE_CLICK: {
    action: "click",
    category: "carousel",
  },
};

export { PRODUCT, TOP_NAV };
